import angular from 'angular';
import CarouselBannerComponent from './carousel-banner.component';

let CarouselBannerModule = angular.module('shared.components.banners.carouselBannerModules.carouselBanner', [])
  .component('carouselBanner', CarouselBannerComponent);

export default CarouselBannerModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/banners/carousel-banner/carousel-banner.js
 **/